import React, { Fragment } from 'react'
// import CarouselHorizontal from '../carousel/carouselHorizontal'
import '../../assets/css/scss/section/_mainBanner.scss'
import HomeBannerSlider from '../carousel/homeBannerSlider'

export default function HomeBannerSection() {
    return (
        <Fragment>
            {/* <!-- banner section --> */}
            <section className="main-banner-section">
                {/* <CarouselHorizontal /> */}
                <HomeBannerSlider />
            </section>
            {/* <!-- banner section --> */}
        </Fragment>
    )
}
